import { jsx } from "react/jsx-runtime";
import ReorderIcon from "@mui/icons-material/Reorder";
import { validateTidalLicense } from "../../base/index.js";
function Reorder(props) {
  return /* @__PURE__ */ jsx(
    ReorderIcon,
    {
      "data-testid": "Reorder",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Reorder",
      "data-tidal-icon-meta": "layout"
    }
  );
}
Reorder.tidalIconMeta = {
  categories: "layout",
  name: "Reorder"
};
validateTidalLicense();
export {
  Reorder
};
//# sourceMappingURL=Reorder.js.map
